import {Component, Input,  OnInit, ViewEncapsulation} from '@angular/core';
import { ImmovableSearchService } from './immovable-search.service';
import { NgxSpinnerService} from 'ngx-spinner';

import { County } from './county.model';
import { Uat } from './uat.model';
import { Locality } from './locality.model';

@Component({
  selector: 'lib-proj1',
  templateUrl: './vizcf.component.html',
  styleUrls: ['./vizcf.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class VizcfComponent implements OnInit {

  // <editor-fold desc="Variables" default="collapsed">

  // <editor-fold desc="Form Data" default="collapsed">
  obj= {
    identifierDetails1: null as number,
    identifierDetails2: null as number,
    identifierDetails3: null as number,
    paperCadNo: null as string,
    topNo: null as string,
    paperLbNo: null as string,
    inscrisCF: 1,
    street: null as string,
    typeTeren: 'option1',
    titleNo: null as string,
    landPlotNo: null as string,
    parcelNo: null as string,
    postalNo: null as string,
    buildingNo: null as string,
    buildingEntryNo: null as string,
    buildingFloorNo: null as string,
    buildingUnitNo: null as string,
    exactSearch: 1
  };
  showUATSelect = true;
  showCountySelect = true;
  searchUnregisteredImmovables = false;
  rezultate: any;
  hasResults = false;
  selectedRowIndex = 1;
  immovable= {
    selectedImmovable: null as any
  };
  searchResultCount: number;
  emptySearch: any;
  // </editor-fold>

  // <editor-fold desc="County Vars" default="collapsed">
  counties: County[];
  selectedCountyId: number;
  clearCounty = false;
  // </editor-fold>

  // <editor-fold desc="UAT Vars" default="collapsed">
  disableUat = true;
  uats: Uat[];
  selectedUatId: number;
  clearUat = false;
  // </editor-fold>

  // <editor-fold desc="Locality Vars" default="collapsed">
  disableLocality = true;
  localities: Locality[];
  selectedLocality: string;
  clearLocality = false;
  // </editor-fold>

  // <editor-fold desc="Table Vars" default="collapsed">
  tableData;
  address: string;
  // </editor-fold>

  // <editor-fold desc="Defaults" default="collapsed">
  cautareExactaDefault = true;
  tipTerenDefault = true;
  inscrisInCFDefault = true;
  showTable = false;
  // </editor-fold>

  // <editor-fold desc="Mesaje" default="collapsed">
  err:any = {
    mesaj: null as string,
    mesajGeneral: null as boolean
  };
  // </editor-fold>

  // <editor-fold desc="Fara tip" default="collapsed">

  advancedSearch = false;

  autocomplete = true;

  disableTarlaAttr = false;

  disableStrParams = true;

  disableStrada = true;

  disableTypeTerenSelection = false;

  isCountySelectListBlocked = false;

  // </editor-fold>

  // <editor-fold desc="Inputs" default="collapsed">
  optiuni = '' as any;

  // </editor-fold>

  // </editor-fold>

  @Input()
  set options(curr: any) {
    this.optiuni = curr;

    if (curr.clearResult != undefined && curr.clearResult == false) {
      this.rezultate = [];
      this.immovable.selectedImmovable = null;
    }

    if (curr.adminUnit != null) {
      this.showUATSelect = false;
      this.selectedUatId = curr.adminUnit;
    } else {
      this.selectedUatId = null;
    }
    this.curataFiltreOnChangeUat();

    if (curr.countyId != null) {
      this.showCountySelect = false;
      this.selectedCountyId = curr.countyId;
    } else {
      this.selectedCountyId = null;
    }
  };

  constructor(private immovableSearchService: ImmovableSearchService, private spinner: NgxSpinnerService) {
  }

  ngOnInit(): void {
    if (!this.isValid(this.optiuni.countyId) && !this.optiuni.hideCountyAndUATSelects) {
      this.showCountySelect = true;
      this.fetchCounties();
    } else {
      this.showCountySelect = false;
      this.fetchUatHierarchy();
    }

    if(this.isValid(this.optiuni.inscrisCF) && this.optiuni.inscrisCF == -1) {
      this.obj.inscrisCF = this.optiuni.inscrisCF;
      this.searchUnregisteredImmovables = true;

      this.showUATSelect = true;
      this.showCountySelect = true;
    }

    if(this.isValid(this.optiuni.exactSearch)) this.obj.exactSearch = this.optiuni.exactSearch;

    if(this.isValid(this.optiuni.searchUnregisteredImmovables)){
      if(this.optiuni.searchUnregisteredImmovables == true){
        this.searchUnregisteredImmovables = true;
        this.obj.inscrisCF = -1;
      }
    }

    if (this.optiuni.hideCountyAndUATSelects) {
      this.showUATSelect = false;
      this.showCountySelect = false;
    }
  }

  fetchUatHierarchy() {
    let counties;
    this.disableUat = false;
    this.immovableSearchService.
    getUatHierarchy().
    subscribe((hierarchyList: any) => {
      this.uats = hierarchyList.map(item => ({id: item.adminUnitId, value: item.adminUnitName}));
      counties = hierarchyList.map(item => item.countyId).filter((value, index, self) => self.indexOf(value) === index);
      this.selectedCountyId = counties[0];

      // not ANCPI user
      if (this.uats[0].id != 1) {
        this.isCountySelectListBlocked = true;
        this.selectedCountyId = counties[0];
      }
    });
  }

  fetchCounties() {
    this.immovableSearchService.
    getCounties().
    subscribe((counties: County[]) => {
      this.counties = counties;
    });
    this.clearCounty = false;
  }

  fetchUats() {
    if (this.selectedCountyId !== null) {
      this.disableUat = false;
    }
    this.immovableSearchService.
    getUats(this.selectedCountyId).
    subscribe((uats: Uat[]) => {
      this.uats = uats;
    });
    this.clearUat = false;
  }

  fetchLocalities() {
    if (this.selectedUatId !== null) {
      this.disableLocality = false;
    }
    this.immovableSearchService.
    getLocalities(this.selectedUatId).
    subscribe((localities: Locality[]) => {
      this.localities = localities;
    });
    this.clearLocality = false;
  }

  modifyParcelAttr() {
    switch (this.obj.typeTeren) {
      case 'option1':
      case 'option5':
        this.disableTarlaAttr = false;
        break;
      case 'option2':
      case 'option3':
      case 'option4':
        this.disableTarlaAttr = true;
        this.obj.titleNo = '';
        this.obj.landPlotNo = '';
        this.obj.parcelNo = '';
        break;
    }
  }

  fetchTableData() {
    this.showTable = true;

    this.rezultate = [];
    let searchObj: any = {};

    this.err.mesajGeneral = false;

    if (!this.isValid(this.selectedCountyId)) {
      this.err.mesaj = 'Va rugam completati campul Judet.';
      this.err.mesajGeneral = true;
      return;
    }

    if (!this.isValid(this.selectedUatId)) {
      this.err.mesaj = 'Va rugam completati campul Uat.';
      this.err.mesajGeneral = true;
      return;
    }

    if (this.isValid(this.selectedCountyId)) {
      searchObj.workspace = this.selectedCountyId;
    }

    if (this.isValid(this.selectedUatId)) {
      searchObj.adminUnit = this.selectedUatId;
    }

    if (this.isValid(this.obj.identifierDetails1)) {
      searchObj.identifierDetails = this.obj.identifierDetails1;
    }
    if (this.isValid(this.obj.identifierDetails2)) {
      searchObj.identifierDetails += '-C' + this.obj.identifierDetails2;
    }
    if (this.isValid(this.obj.identifierDetails3)) {
      searchObj.identifierDetails += '-U' + this.obj.identifierDetails3;
    }

    if (this.isValid(this.obj.paperCadNo)) searchObj.paperCadNo = this.obj.paperCadNo;

    if (this.isValid(this.obj.topNo)) searchObj.topNo = this.obj.topNo;

    if (this.isValid(this.obj.paperLbNo)) searchObj.paperLbNo = this.obj.paperLbNo;

    if (this.isValid(this.obj.inscrisCF)) searchObj.inscrisCF = this.obj.inscrisCF;

    if (this.advancedSearch) {
      if (this.isValid(this.selectedLocality)) {
        searchObj.locality = this.selectedLocality;

        if (this.selectedLocality.indexOf('Bucuresti') >= 0) {
          if (!this.isValid(this.obj.street)) {
            this.err.mesaj = 'Va rugam completati campul Strada';
            this.err.mesajGeneral = true;
          }

          if (this.obj.typeTeren == "option2" || this.obj.typeTeren == 'option3' || this.obj.typeTeren == 'option4') {
            if (!this.isValid(this.obj.postalNo)) {
              if (this.err.mesajGeneral != undefined && this.err.mesajGeneral) {
                this.err.mesaj = this.err.mesaj.replace('campul', 'campurile') + ',NR';
              } else {
                this.err.mesaj = 'Va rugam completati campul NR.';
              }
              this.err.mesajGeneral = true;
            }

            if (this.obj.typeTeren == 'option4') {
              if (!(this.isValid(this.obj.buildingNo) || this.isValid(this.obj.buildingEntryNo) || this.isValid(this.obj.buildingUnitNo))) {
                if (this.err.mesajGeneral != undefined && this.err.mesajGeneral) {
                  this.err.mesaj = this.err.mesaj + ' si cel putin unul dintre campurile: BL,SC,AP.';
                } else {
                  this.err.mesaj = 'Va rugam completati cel putin unul dintre campurile: BL,SC,AP .';
                }
                this.err.mesajGeneral = true;
              }
            }
          }

          if (this.err.mesajGeneral != undefined && this.err.mesajGeneral) {
            return;
          }
        }
      }

      switch (this.obj.typeTeren) {
        case 'option1':
          searchObj.immovableType = 'T';
          break;
        case 'option2':
          searchObj.immovableType = 'C';
          break;
        case 'option3':
          searchObj.immovableType = 'C';
          searchObj.isCondominium = 1;
          break;
        case 'option4':
          searchObj.immovableType = 'A';
          break;
      }

      if (this.isValid(this.obj.street)) searchObj.street = this.obj.street;
      if (this.isValid(this.obj.postalNo)) searchObj.postalNo = this.obj.postalNo;
      if (this.isValid(this.obj.buildingNo)) searchObj.buildingNo = this.obj.buildingNo;
      if (this.isValid(this.obj.buildingEntryNo)) searchObj.buildingEntryNo = this.obj.buildingEntryNo;
      if (this.isValid(this.obj.buildingFloorNo)) searchObj.buildingFloorNo = this.obj.buildingFloorNo;
      if (this.isValid(this.obj.buildingUnitNo)) searchObj.buildingUnitNo = this.obj.buildingUnitNo;

      if (this.isValid(this.obj.titleNo)) {
        searchObj.titleNo = this.obj.titleNo;
        searchObj.immovableType = 'T';
      }
      if (this.isValid(this.obj.landPlotNo)) {
        searchObj.landPlotNo = this.obj.landPlotNo;
        searchObj.immovableType = 'T';
      }
      if (this.isValid(this.obj.parcelNo)) {
        searchObj.parcelNo = this.obj.parcelNo;
        searchObj.immovableType = 'T';
      }
    }

    if(!this.isValid(searchObj.identifierDetails)){

      if(this.isValid(this.obj.paperCadNo) || this.isValid(this.obj.topNo) || this.isValid(this.obj.paperLbNo)){
        let cad: number = this.getValueLikeIE(this.obj.paperCadNo);
        let topo: number = this.getValueLikeIE(this.obj.topNo);
        let cf: number = this.getValueLikeIE(this.obj.paperLbNo);

        let checkIEDto = {
          adminUnitId : this.selectedUatId,
          paperCadNo : Number.isInteger(cad) ? cad : 0,
          topNo : Number.isInteger(topo) ? topo : 0,
          paperCfNo : Number.isInteger(cf) ? cf : 0
        };

        this.immovableSearchService.checkIfIsIE(checkIEDto).subscribe((res: any) => {

          if(this.isValid(res.data) && res.data.modifySearch){
            //cel putin unul din campurile CAD/TOPO/CF este de tipul IE => modificam cautarea
            this.err.mesajGeneral = true;
            if(res.data.cadLikeIE){
              searchObj.identifierDetails = this.calculateIE(this.obj.paperCadNo);
              this.err.mesaj = 'Valoarea completata in campul CAD corespunde formatului IE, cautarea a fost realizata dupa IE!';
            } else if(res.data.topoLikeIE){
              searchObj.identifierDetails = this.calculateIE(this.obj.topNo);
              this.err.mesaj = 'Valoarea completata in campul TOP corespunde formatului IE, cautarea a fost realizata dupa IE!';
            } else if(res.data.cfLikeIE){
              searchObj.identifierDetails = this.calculateIE(this.obj.paperLbNo);
              this.err.mesaj = 'Valoarea completata in campul CF corespunde formatului IE, cautarea a fost realizata dupa IE!';
            }

            this.obj.paperCadNo = undefined;
            this.obj.topNo = undefined;
            this.obj.paperLbNo = undefined;
            searchObj.paperCadNo = undefined;
            searchObj.topNo = undefined;
            searchObj.paperLbNo = undefined;


            this.performSearch(searchObj);

          } else {
            this.performSearch(searchObj);
          }


        });
      } else {
        this.performSearch(searchObj);
      }

    } else {
      this.performSearch(searchObj);
    }
  }

  calculateIE(value: string): string {
    let verifiedIE: string = value.toLowerCase();
    let resultIE: string;
    if(this.isValid(verifiedIE)){
      if(verifiedIE.indexOf('-c') > 0){
        this.obj.identifierDetails1 = parseInt(verifiedIE.substring(0,verifiedIE.indexOf('-c')));
        if(verifiedIE.indexOf('-u') > 0){
          this.obj.identifierDetails2 = parseInt(verifiedIE.substring(verifiedIE.indexOf('-c')+2, verifiedIE.indexOf('-u')));
          this.obj.identifierDetails3 = parseInt(verifiedIE.substring(verifiedIE.indexOf('-u')+2, verifiedIE.length));
        } else if(verifiedIE.indexOf('u') > 0){
          this.obj.identifierDetails2 = parseInt(verifiedIE.substring(verifiedIE.indexOf('-c')+2, verifiedIE.indexOf('u')));
          this.obj.identifierDetails3 = parseInt(verifiedIE.substring(verifiedIE.indexOf('u')+1, verifiedIE.length));
        } else {
          this.obj.identifierDetails2 = parseInt(verifiedIE.substring(verifiedIE.indexOf('-c')+2,verifiedIE.length));
        }
      } else if(verifiedIE.indexOf('c') > 0){
        this.obj.identifierDetails1 = parseInt(verifiedIE.substring(0,verifiedIE.indexOf('c')));
        if(verifiedIE.indexOf('-u') > 0){
          this.obj.identifierDetails2 = parseInt(verifiedIE.substring(verifiedIE.indexOf('c')+1, verifiedIE.indexOf('-u')));
          this.obj.identifierDetails3 = parseInt(verifiedIE.substring(verifiedIE.indexOf('-u')+2, verifiedIE.length));
        } else if(verifiedIE.indexOf('u') > 0){
          this.obj.identifierDetails2 = parseInt(verifiedIE.substring(verifiedIE.indexOf('c')+1, verifiedIE.indexOf('u')));
          this.obj.identifierDetails3 = parseInt(verifiedIE.substring(verifiedIE.indexOf('u')+1, verifiedIE.length));
        } else {
          this.obj.identifierDetails2 = parseInt(verifiedIE.substring(verifiedIE.indexOf('c')+1,verifiedIE.length));
        }
      } else {
        this.obj.identifierDetails1 = parseInt(value);
      }
    }

    if(this.isValid(this.obj.identifierDetails1)){
      resultIE = String(this.obj.identifierDetails1);
    }
    if(this.isValid(this.obj.identifierDetails2)){
      resultIE += '-C' + this.obj.identifierDetails2;
    }
    if(this.isValid(this.obj.identifierDetails3)){
      resultIE += '-U' + this.obj.identifierDetails3;
    }
    return resultIE;
  };

  performSearch(searchObj){
    this.spinner.show();
    this.immovableSearchService.searchImmovable(searchObj,this.advancedSearch,this.obj.exactSearch).subscribe((res: any) => {
      this.spinner.hide();
      this.rezultate = res.content;
      this.hasResults = true;

      if(this.rezultate.length == 1){
        this.selectedRowIndex = 0;
        this.immovable.selectedImmovable = this.rezultate[0];
        if(!this.immovable.selectedImmovable.immovablePk && this.immovable.selectedImmovable.immovableId){
          this.immovable.selectedImmovable.immovablePk = this.immovable.selectedImmovable.immovableId;
        }
      } else {
        this.immovable.selectedImmovable = null;
        this.selectedRowIndex = null;
      }

      this.searchResultCount = res.content.length;

      if ( res.content.length==0 ) {
        this.emptySearch = {};
        this.emptySearch = {
          ie : this.obj.identifierDetails1,
          cad : this.obj.paperCadNo,
          top : this.obj.topNo,
          cf : this.obj.paperLbNo
        };
      }
    });
  }

  getValueLikeIE(value): number {
    if(!this.isValid(value)){
      return;
    }
    let valueLower = value.toLowerCase();
    if(valueLower.indexOf('-c') > 0){
      return parseInt(valueLower.substring(0,valueLower.indexOf('-c')));
    } else if(valueLower.indexOf('c') > 0){
      return parseInt(valueLower.substring(0,valueLower.indexOf('c')));
    } else if(Number.isInteger(parseInt(valueLower))){
      return parseInt(valueLower);
    }
  };

  deleteUats() {
    this.disableUat = true;
    this.disableLocality = true;
    this.selectedUatId = undefined;
    this.curataFiltreOnChangeUat();
    this.selectedLocality = undefined;
    this.obj.street = undefined;
    this.disableStrada = true;
    this.disableStrParams = true;
  }

  deleteLocalities() {
    this.disableLocality = true;
    this.selectedLocality = undefined;
    this.obj.street = undefined;
    this.disableStrada = true;
    this.disableStrParams = true;
  }

  resetSelects() {
    this.clearCounty = true;
    this.clearUat = true;
    this.clearLocality = true;
    this.disableUat = true;
    this.disableLocality = true;
    this.cautareExactaDefault = true;
    this.tipTerenDefault = true;
    this.inscrisInCFDefault = true;
    this.showTable = false;
    this.disableStrada = true;

    this.obj.identifierDetails1 = undefined;
    this.obj.identifierDetails2 = undefined;
    this.obj.identifierDetails3 = undefined;
    this.obj.paperCadNo = undefined;
    this.obj.topNo = undefined;
    this.obj.paperLbNo = undefined;

    this.selectedCountyId = undefined;
    this.selectedUatId = undefined;

    this.err.mesajGeneral = false;

    if(this.advancedSearch){
      this.obj.titleNo = undefined;
      this.obj.landPlotNo = undefined;
      this.obj.parcelNo = undefined;

      this.selectedLocality = undefined;
      this.obj.street = undefined;

      this.obj.postalNo = undefined;
      this.obj.buildingNo = undefined;
      this.obj.buildingEntryNo = undefined;
      this.obj.buildingFloorNo = undefined;
      this.obj.buildingUnitNo = undefined;

      this.disableTarlaAttr=false;
    }
  }

  toggleModeAdvanced() {
    this.advancedSearch = !this.advancedSearch;
  }

  toggleModeAutocomplete() {
    this.autocomplete = !this.autocomplete;
  }

  isValid(value): boolean {
    return (value != undefined && value != null && value !== '');
  }

  getFormatedAddress(elem): string {
    this.address = '';

    if(this.isValid(elem.address.locality)){
      if(this.isValid(elem.address.locality.name)) this.address = this.address + elem.address.locality.name;
    } else {    //adresa de extravilan => intoarcem doar descrierea
      if(this.isValid(elem.address))
        return elem.address.addressDescription;
    }
    if(this.isValid(elem.address.street)){
      if(this.isValid(elem.address.street.dictionaryItem)){
        if(this.isValid(elem.address.street.dictionaryItem.name))  this.address = this.address + ',' + elem.address.street.dictionaryItem.name;
        if(this.isValid(elem.address.street.name)) this.address = this.address + ' ' + elem.address.street.name;
      } else {
        if(this.isValid(elem.address.street.name)) this.address = this.address + ', ' + elem.address.street.name;
      }
    }
    if(this.isValid(elem.address)){
      if(this.isValid(elem.address.postalNo)) this.address = this.address + ',nr. ' + elem.address.postalNo;
      if(this.isValid(elem.address.buildingNo)) this.address = this.address + ',bloc. ' + elem.address.buildingNo;
      if(this.isValid(elem.address.buildingSectionNo)) this.address = this.address + ',tr. ' + elem.address.buildingSectionNo;
      if(this.isValid(elem.address.buildingEntryNo)) this.address = this.address + ',sc. ' + elem.address.buildingEntryNo;
      if(this.isValid(elem.address.buildingFloorNo)) this.address = this.address + ',et. ' + elem.address.buildingFloorNo;
      if(this.isValid(elem.address.buildingUnitNo)) this.address = this.address + ',ap. ' + elem.address.buildingUnitNo;
      if(this.isValid(elem.address.postalCode)) this.address = this.address + ',c.p. ' + elem.address.postalCode;
      if(this.isValid(elem.address.addressDescription)) this.address = this.address + ', ' + elem.address.addressDescription;
    }

    return this.address;
  }

  onChangeIdDet(value: number) {
    if(value === 1){
      if(!this.isValid(this.obj.identifierDetails1)){
        this.obj.identifierDetails2 = undefined;
        this.obj.identifierDetails3 = undefined;
      }
    }
    else{
      if(!this.isValid(this.obj.identifierDetails2)){
        this.obj.identifierDetails3 = undefined;
      }
    }
  }

  disableStreetParams() {
    this.disableStrParams = this.obj.street == '';
  }

  disableStreet() {
    this.disableStrada = true;
    this.disableStrParams = true;
    this.obj.street = undefined;
  }

  enableStreet() {
    this.disableStrada = this.selectedLocality == '';
  }

  curataFiltreOnChangeUat() {
    this.selectedLocality = undefined;
    this.obj.street = undefined;

    this.obj.postalNo = undefined;
    this.obj.buildingNo = undefined;
    this.obj.buildingEntryNo = undefined;
    this.obj.buildingFloorNo = undefined;
    this.obj.buildingUnitNo = undefined;

    this.err.mesajGeneral = false;
  }
}
